import React, { useCallback, useEffect } from 'react';
import { Modal, Tappable } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  selectedSuperBatchModuleSelector,
  setSelectedSuperBatchModule,
  updateSuperBatchModuleIntrviewModalStateSelector,
  setUpdateSuperBatchModuleInterviewModalState,
  useUpdateMenteeModuleFieldsMutation,
} from 'features/moduleManagement';
import GlobalLoader from 'components/GlobalLoader';

function UpdateSuperBatchModuleInterviewModal() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(
    updateSuperBatchModuleIntrviewModalStateSelector
  );

  const selectedMenteeModule = useSelector(selectedSuperBatchModuleSelector);
  const [
    updateSuperBatchModuleIntervieRequired,
    { error, isSuccess, isLoading },
  ] = useUpdateMenteeModuleFieldsMutation();

  const { updatedInterviewRequired, interview_required: interviewRequired } =
    selectedMenteeModule || {};

  const handleOnClose = useCallback(() => {
    batch(() => {
      dispatch(setUpdateSuperBatchModuleInterviewModalState(false));
      dispatch(setSelectedSuperBatchModule(null));
    });
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    updateSuperBatchModuleIntervieRequired({
      id: selectedMenteeModule?.id,
      moduleType: selectedMenteeModule?.academy_module_type,
      interviewRequired: updatedInterviewRequired,
      status: selectedMenteeModule?.status,
    });
  }, [
    selectedMenteeModule,
    updateSuperBatchModuleIntervieRequired,
    updatedInterviewRequired,
  ]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Status changed successfully!');
      batch(() => {
        dispatch(setUpdateSuperBatchModuleInterviewModalState(false));
        dispatch(setSelectedSuperBatchModule(null));
      });
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleOnClose}
      withoutHeader
      className="p-xs"
      canClose={!isLoading}
    >
      <GlobalLoader isVisible={isLoading} />
      <div className="bold dark m-b-10">Confirm Mock Interview Change</div>
      <div>
        Are you sure you want to change the
        <span className="dark bold m-h-5">Mock Interview Status</span>
        for this module from
        <span className="dark bold m-h-5">
          {interviewRequired ? 'Required' : 'Not Required'}
        </span>{' '}
        to
        <span className="dark bold m-h-5">
          {updatedInterviewRequired ? 'Required' : 'Not Required'}
        </span>
        ?
      </div>
      <div className="m-t-xxs row">
        <Tappable
          onClick={handleConfirm}
          disabled={isLoading}
          className="btn btn-primary btn-long m-r-xs"
        >
          Yes
        </Tappable>
        <Tappable
          onClick={handleOnClose}
          disabled={isLoading}
          className="btn btn-inverted btn-long"
        >
          No
        </Tappable>
      </div>
    </Modal>
  );
}

export default UpdateSuperBatchModuleInterviewModal;
